import React from 'react';
import { RandomCssDemo } from './RandomCssDemo';
import { makeDivs } from './utils';

const BOKEH_HTML = makeDivs(50, 'bokeh');
const BOKEH_HTML2 = makeDivs(10, 'bokeh');
const BOKEH_HTML3 = makeDivs(80, 'bokeh');

const BOKEH_SCAFFOLD = `
  body {
    position: absolute;
    inset: 0;
    margin: 0;
    overflow: hidden;
  }

  .bokeh {
    position: absolute;
    border-radius: 100%;
    width: 70px;
    height: 70px;
    background: #fff8;
    z-index: random(1, 100);
  }
`;

const BOKEH_SCAFFOLD2 = `
  ${BOKEH_SCAFFOLD}
  .bokeh {
    --size: random(element-scoped, 50px, 20vmin);
    width: var(--size);
    height: var(--size);
    left: random(0%, calc(100% - var(--size)));
    top: random(0%, calc(100% - var(--size)));
    background: hsl(random(0, 360) 80% 50%);
    opacity: random(0.1, 1);
  }
`;

export function BokehPositionExample() {
  return (
    <RandomCssDemo
      title="Bokeh: Random Position"
      showLoadButton={false}
      htmlBody={BOKEH_HTML2}
      scaffoldCss={BOKEH_SCAFFOLD}
      cssCodeInit={`.bokeh {
  position:absolute;
  left: random(0%, 100%);
  top: random(0%, 100%);
  border-radius: 100%;
}`}
    />
  );
}

export function BokehSizeOvalsExample() {
  return (
    <RandomCssDemo
      title="Bokeh: Random Ovals"
      htmlBody={BOKEH_HTML2}
      showLoadButton={false}
      scaffoldCss={BOKEH_SCAFFOLD}
      cssCodeInit={`.bokeh {
  left: random(0%, 100%);
  top: random(0%, 100%);

  --size: random(50px, 20vmin);
  width: var(--size);
  height: var(--size);
}`}
    />
  );
}

export function BokehElementScopedSizeExample() {
  return (
    <RandomCssDemo
      title="Bokeh: Size Fixed With element-scoped"
      showLoadButton={false}
      htmlBody={BOKEH_HTML}
      scaffoldCss={BOKEH_SCAFFOLD}
      cssCodeInit={`.bokeh {
  top: random(0%, 100%);
  left: random(0%, 100%);

  --size: random(element-scoped, 50px, 20vmin);
  width: var(--size);
  height: var(--size);
}`}
    />
  );
}

export function BokehElementScopedSizeExampleInView() {
  return (
    <RandomCssDemo
      title="Bokeh: Size Fixed With element-scoped"
      showLoadButton={false}
      htmlBody={BOKEH_HTML}
      scaffoldCss={BOKEH_SCAFFOLD}
      cssCodeInit={`.bokeh {
  left: random(0%, calc(100% - var(--size)));
  top: random(0%, calc(100% - var(--size)));

  --size: random(element-scoped, 50px, 20vmin);
  width: var(--size);
  height: var(--size);
}`}
    />
  );
}

export function BokehColorOpacityExample() {
  return (
    <RandomCssDemo
      title="Bokeh: Color and Opacity"
      showLoadButton={false}
      htmlBody={BOKEH_HTML3}
      scaffoldCss={BOKEH_SCAFFOLD}
      cssCodeInit={`.bokeh {
  left: random(0%, calc(100% - var(--size)));
  top: random(0%, calc(100% - var(--size)));
  --size: random(element-scoped, 50px, 20vmin);
  width: var(--size);
  height: var(--size);

  background: hsl(random(0, 360) 80% 50%);
  opacity: random(0.1, 1);
}`}
    />
  );
}

export function BokehBlurBlendExample() {
  return (
    <RandomCssDemo
      title="Bokeh: Blur, Contrast, Blend"
      htmlBody={BOKEH_HTML3}
      showLoadButton={false}
      scaffoldCss={BOKEH_SCAFFOLD2}
      cssCodeInit={`.bokeh {
  filter: blur(random(2px, 6px)) contrast(random(50%, 200%));
  mix-blend-mode: plus-lighter;
}`}
    />
  );
}

export function BokehFinalExample() {
  return (
    <RandomCssDemo
      title="Bokeh: Final Combined Demo"
      htmlBody={BOKEH_HTML3}
      scaffoldCss={BOKEH_SCAFFOLD2}
      cssCodeInit={`.bokeh {
  filter: blur(random(2px, 6px)) contrast(random(50%, 200%));
  mix-blend-mode: plus-lighter;
  animation: pulse random(2s, 5s) ease-in-out infinite;
  animation-delay: random(-5s, 0s);
}

@keyframes pulse {
  50% {
    scale: 1.2;
  }
}`}
    />
  );
}
